/* eslint-disable import/no-anonymous-default-export*/
import {
  AGENT_CREATE_SUCCESS,
  AGENT_CREATE_FAIL,
  REDIRECT,
  LOAN_STATUS_CHANGE_SUCCESS,
  GET_AGENT,
  GET_AGENTS,
  SETTLEMENT_SUCCESS,
  FILTER_AGENTS_BY_LOAN_STATUS,
} from "../actions/types";

const initialState = {
  isLoading: true,
  agents: [],
  agent: null,
  filterdAgents: [],
  loanStatusFilter: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AGENT_CREATE_SUCCESS:
    case LOAN_STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        agent: action.payload,
      };

    case AGENT_CREATE_FAIL:
      return {
        ...state,
        agent: null,
      };

    case SETTLEMENT_SUCCESS:
      return {
        ...state,
        agent: action.payload,
      };

    case GET_AGENT:
      return {
        ...state,
        agent: action.payload,
      };

    case GET_AGENTS:
      return {
        ...state,
        agents: action.payload,
        filterdAgents: action.payload,
      };

    case FILTER_AGENTS_BY_LOAN_STATUS:
      return {
        ...state,
        filterdAgents: action.payload.filterdAgents,
        loanStatusFilter: action.payload.loanStatusFilter,
      };

    case REDIRECT:
      return {
        ...state,
        isLoading: true,
      };

    default:
      return state;
  }
}
